import React, { type FC, type PropsWithChildren } from 'react';

import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';

interface AssociateProfileEmployeeInfoProps {
  label: string;
}

const AssociateProfileEmployeeInfo: FC<PropsWithChildren<AssociateProfileEmployeeInfoProps>> = ({
  label,
  children,
}) => (
  <Box minWidth="100px" maxWidth="250px">
    <Text color="secondary">{label}</Text>
    {children}
  </Box>
);

export default AssociateProfileEmployeeInfo;
